module.exports = __webpack_public_path__ + "img/loot.1be4b80.svg";